import dayjs from 'dayjs';
import { BookingDateException, WorkTimeType } from 'shared/types';

import { getDateFromWorkTime } from '../helpers';

import { getNearestBusinessDay } from './index';

type Props = {
	workTimeAll: WorkTimeType[];
	delay?: number;
	exceptions?: BookingDateException[];
	minPreOrdersDayCount?: number;
};

/**
 * Get { from, till, fromDelayed, tillDelayed } with minimum days before user can make preorder.
 * */
const getNearestPreOrderWorkTime = ({
	minPreOrdersDayCount = 0,
	workTimeAll,
	exceptions,
	delay,
}: Props) => {
	const nearestBusinessDay = getNearestBusinessDay({ workTimeAll, delay, exceptions });
	let preorderDay = dayjs(nearestBusinessDay);

	let count = 0;
	const maxIterations = 7 * minPreOrdersDayCount; // 7 is a week in days

	for (let iterator = 0; count < minPreOrdersDayCount; iterator++) {
		preorderDay = preorderDay.add(1, 'day');

		if (workTimeAll.find((w) => w.dayOfWeek === preorderDay.day())?.active) {
			count += 1;
		}
		if (iterator > maxIterations) break;
	}

	return getDateFromWorkTime({
		workTime: workTimeAll.find((w) => w.dayOfWeek === preorderDay.day())!,
		date: preorderDay.toDate(),
		delay,
	});
};

export default getNearestPreOrderWorkTime;
